import React from 'react';
import Step, { StepProps } from '@material-ui/core/Step';
import StepLabel, { StepLabelProps } from '@material-ui/core/StepLabel';
import { makeStyles, StepConnector, withStyles } from '@material-ui/core';
import Stepper from '@material-ui/core/Stepper';
import classnames from 'classnames';

export interface StepperProps {
    steps: string[];
    activeStep: number;
    errorStep?: number;
    small?: boolean;
}

const useStepIconStyles = makeStyles({
    root: {
        fontSize: '19px',
        color: '#166EFA'
    },
    small: {
        fontSize: '14px',
        marginTop: '4px'
    },
    notActive: {
        color: '#B3C4CB'
    },
    error: {
        color: '#D22F2D'
    }
});

const styledStepIcon =
    (small?: boolean) =>
    ({ active, completed, error, icon }: any) => {
        const classes = useStepIconStyles();

        const rootClassName = classnames(classes.root, {
            [classes.small]: small,
            [classes.notActive]: !active && !completed && !error,
            [classes.error]: error
        });

        return (
            <>
                {active && !error && <i className={`fa-solid fa-circle-${icon} ${rootClassName}`} />}
                {!active && !completed && !error && <i className={`fa-solid fa-circle-${icon} ${rootClassName}`} />}
                {completed && <i className={`fa-solid fa-circle-check ${rootClassName}`} />}
                {error && <i className={`fa-regular fa-triangle-exclamation ${rootClassName}`} />}
            </>
        );
    };

const Connector = withStyles({
    alternativeLabel: {
        top: 9,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)'
    },
    line: {
        height: 2,
        border: 0,
        backgroundColor: '#B3C4CB',
        borderRadius: 2
    }
})(StepConnector);

const Label = withStyles({
    label: {
        '&.MuiStepLabel-label': {
            marginTop: 17,
            color: '#626D7A',
            lineHeight: '22px',
            fontWeight: 700
        }
    },
    active: {
        '&.MuiStepLabel-label': {
            color: '#001D30'
        }
    },
    completed: {
        '&.MuiStepLabel-label': {
            color: '#001D30'
        }
    },
    error: {
        '&.MuiStepLabel-label': {
            color: '#D22F2D'
        }
    }
})(StepLabel);

export const PasslyStepper = ({ steps, activeStep, errorStep, small }: StepperProps) => {
    return (
        <Stepper activeStep={activeStep} connector={<Connector />} alternativeLabel>
            {steps.map((label: string, index: number) => {
                const stepProps: StepProps = {};
                const labelProps: StepLabelProps = {};

                if (errorStep === index) {
                    labelProps.error = true;
                }

                labelProps.StepIconComponent = styledStepIcon(small);

                return (
                    <Step key={label} {...stepProps}>
                        <Label {...labelProps}>{label}</Label>
                    </Step>
                );
            })}
        </Stepper>
    );
};
